
















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import RangeSlider from "@/components/VRangeSliderStyling.vue";

import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';

import * as def from '@/definitions'

import { Design } from '@/model/document2/page/surface/design/design';
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { ColorConstruct } from '@/utilityModels/colorConstruct';
import { ImageLayer } from '@/model/document2/page/surface/design/layer/imageLayer';

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { MathHelper } from "@/helper/mathHelper";
import { ResourceHelper } from "@/helper/resourceHelper";

@Component({
  components: {
      RangeSlider,
      ColorPicker,
      ColorSelector,
      AdjustedBalloon,
      ArrowDown,
      ArrowRight,
      CheckBoxOn
  },
})

export default class MultipleImageShadow extends Vue {

    @Prop() private design!: Design;

    // TextEditorのfocusLockを解除する
    private unlockTextEditorFocus()
    {
        // メッセージセンター取得
        var messageCenter = this.$store.getters.messageCenter;
        // メッセージセンターに送信
        messageCenter.send("unlock_text_editor_focus", null);
    }

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend : true
    };

    multipleImageShadowContentsOpenAnimate = false;
    multipleImageShadowContentsCloseAnimate = false;

    open(){
        if(this.openStatus.opend){
            this.multipleImageShadowContentsCloseAnimate = true;
            setTimeout(()=>{this.multipleImageShadowContentsCloseAnimate = false; this.multipleImageShadowContentsOpenAnimate = false; this.openStatus.opend = false;}, 200);
        }else{
            this.openStatus.opend = true;
            this.multipleImageShadowContentsOpenAnimate = true;
            setTimeout(()=>{this.multipleImageShadowContentsOpenAnimate = false;}, 250);
        }
    };
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    // すべてのレイヤーの特定のパラメータを取得する。
    // 一致していなければ null を返す
    private getLayerProperty(property : string) : any
    {
        var value : any = null;
        var isBreak : boolean = false;

        var allLayers = this.design.getSelectLayerWithoutGroup();
        for(var i = 0; i < allLayers.length; ++i)
        {
            var layer = allLayers[i];
            if(layer instanceof ImageLayer)
            {
                var val = layer[property];
                if(val != null)
                {
                    if(value == null) { value = val; }
                    else if(typeof(value) == "number" && typeof(val) == "number" && MathHelper.equals(value, val)) { value = val; }
                    else if(value instanceof ColorConstruct && val instanceof ColorConstruct && value.equals(val)) { value = val; }
                    else if(value === val) { value = val; }
                    else
                    {
                        isBreak = true;
                        break;
                    }
                }
            }
            if(isBreak) { break; }
        }

        if(isBreak) { return null; }

        return value;
    }

    // 影ON/OFF
    private get isShadow()
    {
        var value = this.getLayerProperty("isShadow");
        return value != null && typeof(value) == "boolean" ? value : false;
    }
    private shadowChange()
    {
        this.changeLayerProperty("isShadow", !this.isShadow, true, true);
    }

    // 影色
    private get shadowColor() : ColorConstruct
    {
        var value = this.getLayerProperty("shadowColor");
        return value != null && value instanceof ColorConstruct ? value : new ColorConstruct();
    }

    private get shadowColorStyle()
    {
        var value = this.getLayerProperty("shadowColor");
        return value == null ? { "border-color" : "#000000", "border-width" : "1px", "border-style" : "solid" } : { "background-color" : value.hex };
    }

    private isShadowColorPickerVisible = false
    private showShadowColorPicker()
    {
        this.isShadowColorPickerVisible = true;
    }
    private closeShadowColorPicker()
    {
        this.isShadowColorPickerVisible = false;
    }

    private onChangingShadowColor(color, tag)
    {
        this.changeLayerProperty(tag, color, false);
    }

    private onChangedShadowColor(color, tag)
    {
        this.changeLayerProperty(tag, color, true);
    }

    // 距離
    private get shadowDistance()
    {
        var value = this.getLayerProperty("shadowDistance");
        return value != null && typeof(value) == "number" ? value : 0;
    }
    private get shadowDistanceDisplay() { return MathHelper.roundByDigits(this.shadowDistance, 2).toFixed(2); }

    private set shadowDistance(shadowDistance)
    {
        this.changeLayerProperty("shadowDistance", shadowDistance, false);
    }

    private onChangeShadowDistance(shadowDistance)
    {
        this.changeLayerProperty("shadowDistance", shadowDistance, true);
    }

    // 角度
    private get shadowRotate()
    {
        var value = this.getLayerProperty("shadowRotate");
        return value != null && typeof(value) == "number" ? value : 0;
    }
    private get shadowRotateDisplay() { return MathHelper.roundByDigits(this.shadowRotate).toFixed(); }

    private set shadowRotate(shadowRotate)
    {
        this.changeLayerProperty("shadowRotate", shadowRotate, false);
    }

    private onChangeShadowRotate(shadowRotate)
    {
        this.changeLayerProperty("shadowRotate", shadowRotate, true);
    }

    // ぼかし
    private get shadowBlur()
    {
        var value = this.getLayerProperty("shadowBlur");
        return value != null && typeof(value) == "number" ? value : 0;
    }
    private get shadowBlurDisplay() { return MathHelper.roundByDigits(this.shadowBlur, 1).toFixed(1); }

    private set shadowBlur(shadowBlur)
    {
        this.changeLayerProperty("shadowBlur", shadowBlur, false);
    }

    private onChangeShadowBlur(shadowBlur)
    {
        this.changeLayerProperty("shadowBlur", shadowBlur, true);
    }

    // 強さ
    private get shadowIntensity()
    {
        var value = this.getLayerProperty("shadowIntensity");
        return value != null && typeof(value) == "number" ? value : 0;
    }
    private get shadowIntensityDisplay() { return MathHelper.roundByDigits(this.shadowIntensity).toFixed(); }

    private set shadowIntensity(shadowIntensity)
    {
        this.changeLayerProperty("shadowIntensity", shadowIntensity, false);
    }

    private onChangeShadowIntensity(shadowIntensity)
    {
        this.changeLayerProperty("shadowIntensity", shadowIntensity, true);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean = false)
    {
        var layers = this.design.getSelectLayerWithoutGroup();

        for(var i = 0; i < layers.length; ++i)
        {
            var layer = layers[i];

            this.$emit("doCommand", "changeLayerProperty", {
                layer : layer,
                propertyName : propertyName,
                value : value,
                isFinish : (isFinish || isOnce) && i == layers.length - 1,
                isOnce : false
            });
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}

